<app-layout>
    <mat-toolbar class="page-header" role="heading">
      <h1>Monthly Holiday Utilisation Report</h1>
    </mat-toolbar>
  
    <div class="content">
      <app-monthly-holiday-utilisation-data-grid></app-monthly-holiday-utilisation-data-grid>
    </div>

</app-layout>